<template>
	<div class="m-code">
		<div v-if="unitData.content" v-html="unitData.content" class="content"></div>
		<p v-else class="unit-empty"></p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-code {
		position: relative;
		overflow: hidden;
		
		>>> .g-content {
			width: 1400px;
			margin: 0 auto;
		}
	}
</style>
